const DefaultConfig = {
  CSS_NAMESPACE: 'nc-Popupify',
}

export { DefaultConfig }
